module.exports = __webpack_public_path__ + "img/heart@2x.d1892b9d.png";